type MSItem = {
  name: string
  stateCodes: Array<string>
  costOfLiving: "low" | "medium" | "high"
}

const MSAsJson: MSItem[] = [
  {
    name: "New York-Newark-Jersey City",
    stateCodes: ["NY", "NJ", "PA"],
    costOfLiving: "high",
  },
  {
    name: "Los Angeles-Long Beach-Anaheim",
    stateCodes: ["CA"],
    costOfLiving: "high",
  },
  {
    name: "Chicago-Naperville-Elgin",
    stateCodes: ["IL", "IN", "WI"],
    costOfLiving: "high",
  },
  {
    name: "Dallas-Fort Worth-Arlington",
    stateCodes: ["TX"],
    costOfLiving: "medium",
  },
  {
    name: "Houston-The Woodlands-Sugar Land",
    stateCodes: ["TX"],
    costOfLiving: "medium",
  },
  {
    name: "Washington-Arlington-Alexandria",
    stateCodes: ["DC", "VA", "MD", "WV"],
    costOfLiving: "high",
  },
  {
    name: "Philadelphia-Camden-Wilmington",
    stateCodes: ["PA", "NJ", "DE", "MD"],
    costOfLiving: "high",
  },
  {
    name: "Atlanta-Sandy Springs-Alpharetta",
    stateCodes: ["GA"],
    costOfLiving: "medium",
  },
  {
    name: "Miami-Fort Lauderdale-Pompano Beach",
    stateCodes: ["FL"],
    costOfLiving: "medium",
  },
  {
    name: "Phoenix-Mesa-Chandler",
    stateCodes: ["AZ"],
    costOfLiving: "medium",
  },
  {
    name: "Boston-Cambridge-Newton",
    stateCodes: ["MA", "NH"],
    costOfLiving: "high",
  },
  {
    name: "Riverside-San Bernardino-Ontario",
    stateCodes: ["CA"],
    costOfLiving: "high",
  },
  {
    name: "San Francisco-Oakland-Berkeley",
    stateCodes: ["CA"],
    costOfLiving: "high",
  },
  {
    name: "Detroit-Warren-Dearborn",
    stateCodes: ["MI"],
    costOfLiving: "medium",
  },
  {
    name: "Seattle-Tacoma-Bellevue",
    stateCodes: ["WA"],
    costOfLiving: "high",
  },
  {
    name: "Minneapolis-St Paul-Bloomington",
    stateCodes: ["MN"],
    costOfLiving: "medium",
  },
  {
    name: "San Diego-Chula Vista-Carlsbad",
    stateCodes: ["CA"],
    costOfLiving: "high",
  },
  {
    name: "Tampa-St Petersburg-Clearwater",
    stateCodes: ["FL"],
    costOfLiving: "medium",
  },
  {
    name: "Denver-Aurora-Lakewood",
    stateCodes: ["CO"],
    costOfLiving: "medium",
  },
  {
    name: "Baltimore-Columbia-Towson",
    stateCodes: ["MD"],
    costOfLiving: "medium",
  },
  {
    name: "St Louis",
    stateCodes: ["MO", "IL"],
    costOfLiving: "low",
  },
  {
    name: "Charlotte-Concord-Gastonia",
    stateCodes: ["NC", "SC"],
    costOfLiving: "medium",
  },
  {
    name: "Orlando-Kissimmee-Sanford",
    stateCodes: ["FL"],
    costOfLiving: "medium",
  },
  {
    name: "San Antonio-New Braunfels",
    stateCodes: ["TX"],
    costOfLiving: "low",
  },
  {
    name: "Portland-Vancouver-Hillsboro",
    stateCodes: ["OR", "WA"],
    costOfLiving: "high",
  },
  {
    name: "Sacramento-Roseville-Folsom",
    stateCodes: ["CA"],
    costOfLiving: "high",
  },
  {
    name: "Pittsburgh",
    stateCodes: ["PA"],
    costOfLiving: "low",
  },
  {
    name: "Austin-Round Rock-Georgetown",
    stateCodes: ["TX"],
    costOfLiving: "medium",
  },
  {
    name: "Las Vegas-Henderson-Paradise",
    stateCodes: ["NV"],
    costOfLiving: "medium",
  },
  {
    name: "Cincinnati",
    stateCodes: ["OH", "KY", "IN"],
    costOfLiving: "low",
  },
  {
    name: "Kansas City",
    stateCodes: ["MO", "KS"],
    costOfLiving: "low",
  },
  {
    name: "Columbus",
    stateCodes: ["OH"],
    costOfLiving: "medium",
  },
  {
    name: "Indianapolis-Carmel-Anderson",
    stateCodes: ["IN"],
    costOfLiving: "medium",
  },
  {
    name: "Cleveland-Elyria",
    stateCodes: ["OH"],
    costOfLiving: "low",
  },
  {
    name: "Nashville-Davidson-Murfreesboro-Franklin",
    stateCodes: ["TN"],
    costOfLiving: "medium",
  },
  {
    name: "San Jose-Sunnyvale-Santa Clara",
    stateCodes: ["CA"],
    costOfLiving: "high",
  },
  {
    name: "Virginia Beach-Norfolk-Newport News",
    stateCodes: ["VA", "NC"],
    costOfLiving: "medium",
  },
  {
    name: "Providence-Warwick",
    stateCodes: ["RI", "MA"],
    costOfLiving: "high",
  },
  {
    name: "Jacksonville",
    stateCodes: ["FL"],
    costOfLiving: "medium",
  },
  {
    name: "Milwaukee-Waukesha",
    stateCodes: ["WI"],
    costOfLiving: "medium",
  },
  {
    name: "Raleigh-Cary",
    stateCodes: ["NC"],
    costOfLiving: "medium",
  },
  {
    name: "Oklahoma City",
    stateCodes: ["OK"],
    costOfLiving: "low",
  },
  {
    name: "Memphis",
    stateCodes: ["TN", "MS", "AR"],
    costOfLiving: "medium",
  },
  {
    name: "Richmond",
    stateCodes: ["VA"],
    costOfLiving: "low",
  },
  {
    name: "Louisville-Jefferson County",
    stateCodes: ["KY", "IN"],
    costOfLiving: "low",
  },
  {
    name: "Salt Lake City",
    stateCodes: ["UT"],
    costOfLiving: "medium",
  },
  {
    name: "New Orleans-Metairie",
    stateCodes: ["LA"],
    costOfLiving: "medium",
  },
  {
    name: "Hartford-East Hartford-Middletown",
    stateCodes: ["CT"],
    costOfLiving: "high",
  },
  {
    name: "Buffalo-Cheektowaga",
    stateCodes: ["NY"],
    costOfLiving: "medium",
  },
  {
    name: "Birmingham-Hoover",
    stateCodes: ["AL"],
    costOfLiving: "low",
  },
]

export default MSAsJson
